import PlaceholderActions from "./Actions";
import PlaceholderBody from "./Body";
import PlaceholderTitle from "./Title";
import PlaceholderWrapper from "./Wrapper";

export default {
  Actions: PlaceholderActions,
  Body: PlaceholderBody,
  Title: PlaceholderTitle,
  Wrapper: PlaceholderWrapper
};
